;(function (angular) {
  'use strict'

  angular
    .module('kilo.routes.inbox.list', [])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = [ '$stateProvider' ]

  function RouteConfigurator ($stateProvider) {
    var showState = {
      name: 'inbox.list',
      url: '/list',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) { pagination.destroy() }],
      title: 'BOÎTE DE RECEPTION',
      resolve: {
        pagination: [ 'PaginationModel', function (PaginationModel) {
          return PaginationModel.get('inboxList')
        } ]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/inbox/list/templates/inbox-list.template.html',
          controller: 'InboxListController',
          controllerAs: 'list'
        }
      },
      ncyBreadcrumb: {
        label: 'Boîte de réception'
      }
    }
    $stateProvider
      .state(showState)
  }
})(window.angular)
